import type { IndependentAction } from '@lighthouse/core'
import { ActionHandleEventType, FlowSelectSourceType, PAGE_STACK_DISPLAY_TYPE, type VariableADTvalue, VariableType } from '@lighthouse/core'
import { nanoid } from '@lighthouse/tools'

export const getIndependentActionsMap = (actionId?: string) => {
    const id = actionId || nanoid()
    return new Map<ActionHandleEventType, IndependentAction>([
        [
            ActionHandleEventType.CREATE_RECORD,
            {
                id,
                type: ActionHandleEventType.CREATE_RECORD,
                data: {
                    createRecord: {
                        dataSourceId: '',
                        fields: []
                    }
                }
            }
        ],
        [
            ActionHandleEventType.DELETE_RECORD,
            {
                id,
                type: ActionHandleEventType.DELETE_RECORD,
                data: {
                    deleteRecord: {
                        selectType: FlowSelectSourceType.DATASOURCE,
                        dataSourceId: '',
                        nodeId: ''
                    }
                }
            }
        ],
        [
            ActionHandleEventType.UPDATE_RECORD,
            {
                id,
                type: ActionHandleEventType.UPDATE_RECORD,
                data: {
                    updateRecord: {
                        selectType: FlowSelectSourceType.DATASOURCE,
                        dataSourceId: '',
                        nodeId: '',
                        fields: []
                    }
                }
            }
        ],
        [
            ActionHandleEventType.OPEN_LINK,
            {
                id,
                type: ActionHandleEventType.OPEN_LINK,
                data: {
                    openLink: {
                        link: {},
                        target: '_blank'
                    }
                }
            }
        ],
        [
            ActionHandleEventType.SCROLL_TO,
            {
                id,
                type: ActionHandleEventType.SCROLL_TO,
                data: {
                    scrollTo: {
                        scrollToElementId: ''
                    }
                }
            }
        ],
        [
            ActionHandleEventType.CONTROL,
            {
                id,
                type: ActionHandleEventType.CONTROL,
                data: {
                    control: {
                        controlElementId: '',
                        controlElementType: 'view'
                    }
                }
            }
        ],
        [
            ActionHandleEventType.OPEN_PAGE,
            {
                id,
                type: ActionHandleEventType.OPEN_PAGE,
                data: {
                    openPage: {
                        openPageId: '',
                        pageOpenType: PAGE_STACK_DISPLAY_TYPE.modal
                    }
                }
            }
        ],
        [
            ActionHandleEventType.GO_BACK,
            {
                id,
                type: ActionHandleEventType.GO_BACK,
                data: {
                    goBack: {}
                }
            }
        ],
        [
            ActionHandleEventType.NOTIFICATION,
            {
                id,
                type: ActionHandleEventType.NOTIFICATION,
                data: {
                    notification: {
                        notificationContent: {},
                        notificationStatus: 'INFO'
                    }
                }
            }
        ],
        [
            ActionHandleEventType.COPY,
            {
                id,
                type: ActionHandleEventType.COPY,
                data: {
                    copy: {
                        copyText: {}
                    }
                }
            }
        ],
        [
            ActionHandleEventType.DOWNLOAD_FILE,
            {
                id,
                type: ActionHandleEventType.DOWNLOAD_FILE,
                data: {
                    downloadFile: {
                        fileUrl: {
                            type: VariableType.VALUE
                        }
                    }
                }
            }
        ],
        [
            ActionHandleEventType.WECHAT_PAY,
            {
                id,
                type: ActionHandleEventType.WECHAT_PAY,
                data: {
                    wechatPay: {
                        selectType: FlowSelectSourceType.DATASOURCE,
                        nodeId: '',
                        dataSourceId: '',

                        descFieldId: '',
                        autoRedirectAfterPayment: true,
                        amountFieldId: '',
                        succeedFieldSettings: [],
                        callbackWorkflow: {
                            workflowId: '',
                            workflowArgs: []
                        }
                        // failedFieldSettings: []
                        // refundConfig: {
                        //     // 订单id对应的字段id
                        //     outTradeNoFieldId: '',
                        //     refundAmountFieldId: '',
                        //     reasonFieldId: '',
                        //     succeedFieldSettings: [],
                        //     // failedFieldSettings: []
                        // }
                    }
                }
            }
        ],
        [
            ActionHandleEventType.CALL,
            {
                id,
                type: ActionHandleEventType.CALL,
                data: {
                    call: {
                        phone: {
                            type: 'VALUE'
                        } as VariableADTvalue
                    }
                }
            }
        ],
        [
            ActionHandleEventType.WECHAT_TEMPLATE_MSG,
            {
                id,
                type: ActionHandleEventType.WECHAT_TEMPLATE_MSG,
                data: {
                    wechatTemplateMsg: {
                        personList: [],
                        templateId: '',
                        values: [],
                        url: {}
                    }
                }
            }
        ],
        [
            ActionHandleEventType.STRIPE,
            {
                id,
                type: ActionHandleEventType.STRIPE,
                data: {
                    stripe: {
                        selectType: FlowSelectSourceType.DATASOURCE,
                        nodeId: '',
                        dataSourceId: '',
                        autoRedirectAfterPayment: true,
                        productPictureFieldId: '',
                        currency: '',
                        descFieldId: '',
                        productNameFieldId: '',
                        amountFieldId: '',
                        succeedFieldSettings: [],
                        callbackWorkflow: {
                            workflowId: '',
                            workflowArgs: []
                        }
                        // failedFieldSettings: []
                    }
                }
            }
        ],
        [
            ActionHandleEventType.UPDATE_PAGE_STATE,
            {
                id,
                type: ActionHandleEventType.UPDATE_PAGE_STATE,
                data: {
                    updatePageState: {
                        pageStateId: ''
                    }
                }
            }
        ],
        [
            ActionHandleEventType.UPDATE_QUERY_PARAMETER,
            {
                id,
                type: ActionHandleEventType.UPDATE_QUERY_PARAMETER,
                data: {
                    updateQueryParameter: {
                        queryParameterId: ''
                    }
                }
            }
        ],
        [
            ActionHandleEventType.UPDATE_PAGE_SHARE,
            {
                id,
                type: ActionHandleEventType.UPDATE_PAGE_SHARE,
                data: {
                    updatePageShare: {}
                }
            }
        ],
        [
            ActionHandleEventType.REFRESH_PAGE,
            {
                id,
                type: ActionHandleEventType.REFRESH_PAGE,
                data: {
                    refreshPage: {}
                }
            }
        ],
        [
            ActionHandleEventType.ALIYUN_MESSAGE,
            {
                id,
                type: ActionHandleEventType.ALIYUN_MESSAGE,
                data: {
                    aliyunMessage: {
                        id: '',
                        mobileList: {
                            type: 'VALUE'
                        } as VariableADTvalue,
                        signatureId: '',
                        templateId: '',
                        values: []
                    }
                }
            }
        ],
        [
            ActionHandleEventType.CLOSE_FLOAT,
            {
                id,
                type: ActionHandleEventType.CLOSE_FLOAT,
                data: {
                    closeFloat: {}
                }
            }
        ],
        [
            ActionHandleEventType.SCREEN_SHOT,
            {
                id,
                type: ActionHandleEventType.SCREEN_SHOT,
                data: {
                    screenShot: {
                        screenShotElementId: '',
                        scale: '0.5'
                    }
                }
            }
        ],
        [
            ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG,
            {
                id,
                type: ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG,
                data: {
                    wechatSubscriptionMsg: {
                        templateIds: []
                    }
                }
            }
        ],
        [
            ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG_NOTIFICATION,
            {
                id,
                type: ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG_NOTIFICATION,
                data: {
                    wechatSubscriptionMsgNotification: {
                        personList: [],
                        templateId: '',
                        values: [],
                        page: {
                            openPageId: '',
                            pathParameters: [],
                            queryParameters: []
                        }
                    }
                }
            }
        ]
    ])
}
